import useApi from "./useApiRequest";
import { useMutation } from "react-query";

export const GetAllPartesList = ()  => {
    const api = useApi();

    const mutate = async () => {
        const data  = await api.get(`/partes/list`);
        return data.data;
    };

    const mutation = useMutation(mutate);

    return {
        getAllPartesListMutation: mutation.mutate,
    };
}